import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';
import ColorVars from '@styles/color.styled';

const GlobalStyle = createGlobalStyle`

  ${reset}

  :root {
    ${ColorVars}
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    margin: 0;
    min-height: 100vh;
    font-family: ${(props) => props.theme.fontFamily.text};
    font-size: 1.125rem;
    overflow-x: hidden;
    background-color: ${(props) => props.theme.colors.dark};

    /* Add dynamic top padding when ticker is visible to prevent content overlap */
    &.ticker-visible {
      padding-top: var(--ticker-height, 3rem);

      @media only screen and (max-width: ${(props) => props.theme.breakpoints.md}) {
        padding-top: var(--ticker-height-mobile, 2.5rem);
      }
    }
  }

  *, *:before, *:after {
    box-sizing: border-box;
  }

  p {
    margin: 0;
  }
`;

export default GlobalStyle;
